import { Box, styled } from "@mui/material";

export const DetailedBlockOffModalStyled  = styled(Box)`
    .repeat-interval{
        font-weight: 600;
    }
`;
